import {isVersionAlias} from '@wandb/weave/common/util/artifacts';
// @todo: Migrate to 'Toast' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {toast} from 'react-toastify';

import {TagInput} from '../../generated/graphql';
import * as GQLTypes from '../../types/graphql';
import {
  createAttributesString,
  ModifiedTag,
  parseTag,
  TagAttributes,
} from '../TagAssignment';

type AliasVariables = {
  artifactID: string;
  aliases: Array<{
    alias: string;
    entityName: string;
    projectName: string;
    artifactCollectionName: string;
  }>;
};

type RemoveTagVariables = {
  artifactID: string;
  tags: Array<{
    tagCategoryName: string;
    tagName: string;
  }>;
};

type AddTagVariables = {
  artifactID: string;
  tags: TagInput[];
};

type MutationFunction<T> = (options: {variables: T}) => Promise<any>;

export const handleAddAlias = async (
  alias: string,
  artifactID: string,
  entityName: string,
  projectName: string,
  artifactCollectionName: string,
  addAliases: MutationFunction<AliasVariables>,
  refetch: () => void
) => {
  if (isVersionAlias({alias})) {
    return;
  }
  try {
    await addAliases({
      variables: {
        artifactID,
        aliases: [
          {
            alias,
            entityName,
            projectName,
            artifactCollectionName,
          },
        ],
      },
    });
    refetch();
  } catch (error) {
    console.error(error);
    toast('Something went wrong when trying to add this alias.');
  }
};

export const handleDeleteAlias = async (
  alias: string,
  artifactID: string,
  entityName: string,
  projectName: string,
  artifactCollectionName: string,
  deleteAliases: MutationFunction<AliasVariables>,
  refetch: () => void
) => {
  if (isVersionAlias({alias})) {
    return;
  }
  try {
    await deleteAliases({
      variables: {
        artifactID,
        aliases: [
          {
            alias,
            entityName,
            projectName,
            artifactCollectionName,
          },
        ],
      },
    });
    refetch();
  } catch (error) {
    console.error(error);
    toast('Something went wrong when trying to delete this alias.');
  }
};

export const handleRemoveTagAssignment = async (
  tag: ModifiedTag,
  artifactID: string,
  removeTagAssignment: MutationFunction<RemoveTagVariables>,
  refetch: () => void
) => {
  try {
    await removeTagAssignment({
      variables: {
        artifactID,
        tags: [
          {
            tagCategoryName: tag.tagCategoryName,
            tagName: tag.name,
          },
        ],
      },
    });
    refetch();
  } catch (error) {
    console.error(error);
    toast('Something went wrong when trying to delete this tag.');
  }
};

export const handleAddTagAssignment = async (
  tagInput: GQLTypes.Tag,
  artifactID: string,
  addTagAssignment: MutationFunction<AddTagVariables>,
  refetch: () => void
) => {
  try {
    const tagStr = tagInput.name;

    // Parse input string into tag and category
    const [tagCategoryName, tagName] = parseTag(tagStr);

    // Stringify Attributes
    const tagAttributes: TagAttributes = {
      color: tagInput.colorIndex,
      icon: tagInput.icon,
    };
    const attributesStr = createAttributesString(tagAttributes);
    await addTagAssignment({
      variables: {
        artifactID,
        tags: [
          {
            tagCategoryName,
            tagName,
            attributes: attributesStr,
          },
        ],
      },
    });
    refetch();
  } catch (err) {
    console.error(err);
    toast(
      'Something went wrong when trying to create this tag. Please check for special characters.'
    );
  }
  return;
};
